import { IS_LIVE_CHANGED } from '../actions/is-live';
import { CONTESTS_SHOW_SUCCESS } from '../actions/contests';
import oget from 'oget';

const defaultState = {
    athleteId: null,
    heatId: null,
    changed: false
};

export default (state = defaultState, { type, payload = {} }) => {
    switch (type) {
        case IS_LIVE_CHANGED: {
            return {
                ...state,
                changed: true
            }
        }

        case CONTESTS_SHOW_SUCCESS: {
            const { selectedRound } = payload;

            const heats = oget(
                selectedRound,
                'heats',
                []
            );

            const liveHeat = heats
            .map(heat => {
                const { athletesById } = heat;

                const liveAthleteId = Object.keys(athletesById)
                .reduce((prev, key) => {
                    if (prev === null && athletesById[key].isLive) {
                        return key;
                    }

                    return prev;
                }, null);

                return {
                    athleteId: liveAthleteId,
                    heatId: heat.externalId
                };
            })
            .reduce((prev, heat) => {
                if (prev === null && !!heat.athleteId) {
                    return heat;
                }

                return prev;
            }, null);

            if (!liveHeat) {
                return state;
            }

            const {
                athleteId,
                heatId
            } = liveHeat;

            if (
                athleteId === state.athleteId
                && heatId === state.heatId
            ) {
                return state;
            }

            return {
                athleteId,
                heatId,
                changed: false
            };
        }

        default: {
            return state;
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/reducers/is-live.js